"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePermissions = void 0;
var react_1 = require("react");
var PermissionContext_1 = require("@/Components/common/PermissionContext");
var usePermissions = function () {
    var userPermissions = (0, react_1.useContext)(PermissionContext_1.PermissionsContext).userPermissions;
    var checkPermission = function (permission, resourceId, resourceType) {
        var hasGlobalManagerPermission = userPermissions.some(function (userPermission) {
            // Checks if the user has a global manager permission based on the permission property
            return userPermission.name === permission
                && permission.includes("global")
                && permission.includes("manager");
        });
        if (hasGlobalManagerPermission) {
            return true;
        }
        if (resourceId !== undefined && resourceType !== undefined) {
            return userPermissions.some(function (userPermission) {
                return userPermission.name === permission &&
                    userPermission.resourceId === resourceId &&
                    userPermission.resourceType === resourceType;
            });
        }
        else if (resourceId !== undefined) {
            return userPermissions.some(function (userPermission) {
                return userPermission.name === permission && userPermission.resourceId === resourceId;
            });
        }
        else if (resourceType !== undefined) {
            return userPermissions.some(function (userPermission) {
                return userPermission.name === permission && userPermission.resourceType === resourceType;
            });
        }
        return userPermissions.some(function (userPermission) { return userPermission.name === permission; });
    };
    var hasPermission = function (permission, resourceId, resourceType) {
        if (Array.isArray(permission)) {
            return permission.some(function (perm) { return checkPermission(perm, resourceId, resourceType); });
        }
        else {
            return checkPermission(permission, resourceId, resourceType);
        }
    };
    return { hasPermission: hasPermission };
};
exports.usePermissions = usePermissions;
